import { Link } from "@tanstack/react-router";
import { useMerchant } from "@/providers/MerchantProvider";

type Props = {
  collaborationId: string;
  layout?: "stacked" | "inline";
};

function FindMoreCreatorsIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" aria-hidden="true">
      <path
        d="M9.99932 4.66675V2.66675L11.9993 0.666748L12.666 2.00008L13.9993 2.66675L11.9993 4.66675H9.99932ZM9.99932 4.66675L7.33266 7.33338M13.9993 7.33341C13.9993 11.0153 11.0146 14.0001 7.33268 14.0001C3.65078 14.0001 0.666016 11.0153 0.666016 7.33341C0.666016 3.65152 3.65078 0.666748 7.33268 0.666748M10.666 7.33341C10.666 9.17436 9.17363 10.6667 7.33268 10.6667C5.49173 10.6667 3.99935 9.17436 3.99935 7.33341C3.99935 5.49247 5.49173 4.00008 7.33268 4.00008"
        stroke="#F4EBFF"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function FindMoreCreatorsCard({ collaborationId, layout = "stacked" }: Props) {
  const merchant = useMerchant();

  const browseLink = (
    <Link
      to="/merchant/$merchantId/collaborations/target/$collaborationId/recommendations"
      params={{ merchantId: merchant, collaborationId }}
      className="text-sm font-medium text-white underline underline-offset-2 hover:text-white/80 inline-flex items-center gap-1 w-fit"
    >
      Browse Our Recommendations
    </Link>
  );

  if (layout === "inline") {
    return (
      <div className="flex-shrink-0 rounded-xl border border-white/15 bg-white/[0.04] px-4 py-3 flex flex-col gap-2 panels-wide:flex-row panels-wide:items-center panels-wide:gap-3">
        <div className="flex items-center gap-2">
          <FindMoreCreatorsIcon />
          <span className="text-sm font-semibold text-white">Find more creators.</span>
        </div>
        {browseLink}
      </div>
    );
  }

  return (
    <div className="flex-shrink-0 w-72 rounded-xl border border-white/15 bg-white/[0.04] p-4 flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <FindMoreCreatorsIcon />
        <span className="text-sm font-semibold text-white">Find more creators.</span>
      </div>
      {browseLink}
    </div>
  );
}
